// extracted by mini-css-extract-plugin
export var equalColumn = "_fj-0";